import type {Env} from '@hconnect/common/hproduce/whiteListCheck'
import {getSupportedLanguages} from '@hconnect/common/utils'
import {useLoginContext, useUserContext} from '@hconnect/login'
import {CommonHeader, NavItem} from '@hconnect/uikit/src/lib2'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {usePermissionsQuery} from '@hproduce/permissions'
import {ROUTES as REFRA_FEATURE_ROUTES} from '@refra/modules/routing/routes'
import {useTranslation} from 'react-i18next'
import {useLocation, useNavigate} from 'react-router'

import {useUrlParam} from '../../../routing/hooks'

export const RefraPlannerHeader: React.FC = () => {
  const {t, i18n} = useTranslation()
  const plantCode = useUrlParam('plantCode')

  const upmPlants = useUpmPlantsContext()

  const navigate = useNavigate()
  const location = useLocation()

  const {logout} = useLoginContext()
  const {loggedUser} = useUserContext()

  const {data: permissions} = usePermissionsQuery()
  if (permissions === undefined) {
    throw new Error('Permissions data must be loaded beforehand')
  }

  const navItems: NavItem[] = [
    {
      label: t('refraCatalog.title'),
      url: REFRA_FEATURE_ROUTES.REFRA_CATALOG.path,
      dataTestId: 'navItem_refraCatalog',
      id: 'nav-item-refra-catalog'
    },
    {
      label: t('refraPlanning.title'),
      url: REFRA_FEATURE_ROUTES.REFRA_PLANNING.path,
      dataTestId: 'navItem_refraPlanning',
      id: 'nav-item-refra-planning'
    },
    {
      label: t('staticParts.title'),
      url: REFRA_FEATURE_ROUTES.STATIC_PARTS.path,
      dataTestId: 'navItem_refraStaticParts',
      id: 'nav-item-refra-static-parts'
    },
    {
      label: t('flexibleReport.title'),
      url: REFRA_FEATURE_ROUTES.FLEXIBLE_REPORT.path,
      dataTestId: 'navItem_refraFlexibleReport',
      id: 'nav-item-refra-flexible-report'
    }
  ]

  return (
    <CommonHeader
      appName="RefraPlanner"
      plant={{plantId: plantCode, plantName: getPlantName(upmPlants, plantCode)}}
      upmPlants={upmPlants}
      navItems={navItems}
      supportedLanguages={getSupportedLanguages(i18n)}
      user={{email: loggedUser?.eMail ?? undefined, name: loggedUser?.name ?? undefined}}
      navigate={navigate}
      locationPath={location.pathname}
      permissions={permissions}
      env={process.env.REACT_APP_STAGE as Env}
      onLogout={() => void logout()}
    />
  )
}
